import { TextSize, Weight } from 'components/typography/text'

import styled from 'styled-components'

/**
 * Wraps the balance checker area
 */
export const BalanceCheckerWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  font-size: ${TextSize.small};
  font-weight: ${Weight.SemiBold};
  width: fill-available;
  margin: 0 20px;
  height: 35px;
  max-width: 100%;
`

/**
 * Wraps each flex item in the balance checker area
 */
export const BalanceCheckerItem = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
`

/**
 * Custom max span
 */
export const BalanceCheckerItemMaxSpan = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
`
